<div class="overlay">
    <div class="container mt-5">
      <div class="row d-flex justify-content-center" *ngIf="!checkPayLoad && !loadPay">
           <app-app-info [fromSetup]="true"></app-app-info>
      </div>

      <app-spinner *ngIf="checkPayLoad" [loading]="checkPayLoad"></app-spinner>

      <app-spinner *ngIf="loadPay" [loading]="loadPay" [text]="'მიმდინარეობს გადახდის შემოწმება'"></app-spinner>

    </div>
</div>